import React from 'react';
import styles from './RsoForm.module.scss';
import { Form } from 'antd';
import TablePreview from '../../common/TablePreview/TablePreview';
import ExcelImportWizard from '../ExcelImportWizard/ExcelImportWizard';
import CompanyBox from '../CompanyBox/CompanyBox';
import { useSelector } from 'react-redux';
import ViewContainerTable from '../../common/ViewContainerTable/ViewContainerTable';
import useSyncRsoForm from '../../../hooks/useSyncRsoForm';

const RsoFormNode = ({ form, onClickFetch }) => {
  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const { data } = useSelector((state) => state.rsoImportStore);

  const hasData = data.length > 0;

  useSyncRsoForm(form);

  return (
    <Form
      form={form}
      className={styles.formBox}
    >
      <div className={styles.containerPreview}>
        <div className={styles.boxWizard}>
          <CompanyBox form={form} />
          <ExcelImportWizard
            form={form}
            visible={Boolean(currentCompany)}
            onClickFetch={onClickFetch}
          />
        </div>
        <TablePreview />
      </div>
      {hasData && <ViewContainerTable form={form} />}
    </Form>
  );
};

const RsoForm = Form.create('RsoForm')(RsoFormNode);

export default RsoForm;
